import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import { getUserToken } from '@/utils/user'
import Api from '@/api'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      redirect:'/index',
      children:[
        {
          path: '/index',
          name: 'Index',
          component: () => import('@/views/Index/index'),
          meta: { title: '新华网大语言模型集成测试服务平台' }
        },
        {
          path: '/aiHome',
          name: 'AiHome',
          component: () => import('@/views/AiHome'),
          meta: { title: '新华网大语言模型集成测试服务平台' },
        },
        {
          path: '/aiwenda',
          name: 'Aiwenda',
          component: () => import('@/views/Aiwenda'),
          meta: { title: '新华网大语言模型集成测试服务平台' },
          beforeEnter: (to, from, next) => {
            const token = getUserToken()
            if(!token) {
              next({
                path: '/aiHome'
              })
            }
            Api.verifyToken(token).then(res => {
              if ( res.code === 200 && res.data.canCheck ) {
                next()
              } else {
                next({
                  path: '/aiHome'
                })
              }
            }).catch(err => {
              next({
                path: '/aiHome'
              })
            })
          }
        },
 
        {
          path: '/aiImgwenda',
          name: 'AiImgwenda',
          component: () => import('@/views/AiImgwenda'),
          meta: { title: '新华网大语言模型集成测试服务平台' },
          beforeEnter: (to, from, next) => {
            const token = getUserToken()
            if(!token) {
              next({
                path: '/aiHome'
              })
            }
            Api.verifyToken(token).then(res => {
              if ( res.code === 200 && res.data.canCheck ) {
                next()
              } else {
                next({
                  path: '/aiHome'
                })
              }
            }).catch(err => {
              next({
                path: '/aiHome'
              })
            })
          }
        },
        {
          path: '/aiToolwenda',
          name: 'AiToolwenda',
          component: () => import('@/views/AiToolwenda'),
          meta: { title: '新华网大语言模型集成测试服务平台' },
          beforeEnter: (to, from, next) => {
            const token = getUserToken()
            if(!token) {
              next({
                path: '/aiHome'
              })
            }
            Api.verifyToken(token).then(res => {
              if ( res.code === 200 && res.data.canCheck ) {
                next()
              } else {
                next({
                  path: '/aiHome'
                })
              }
            }).catch(err => {
              next({
                path: '/aiHome'
              })
            })
          }
        },
        {
          path: '/ai',
          name: 'Ai',
          component: () => import('@/views/Ai'),
          meta: { title: '新华网大语言模型集成测试服务平台' },
          beforeEnter: (to, from, next) => {
            const token = getUserToken()
            if(!token) {
              next({
                path: '/aiHome'
              })
            }
            Api.verifyToken(token).then(res => {
              if ( res.code === 200 && res.data.canCheck ) {
                next()
              } else {
                next({
                  path: '/aiHome'
                })
              }
            }).catch(err => {
              next({
                path: '/aiHome'
              })
            })
          }
        },
      ]
    },
    {
      path: '/content',
      name: 'Content',
      component: () => import('@/views/ContentSecurity'),
      meta: { title: '新华网大语言模型集成测试服务平台' },
      beforeEnter: (to, from, next) => {
        const token = getUserToken()
        if(!token) {
          next({
            path: '/aiHome'
          })
        }
        Api.verifyToken(token).then(res => {
          if ( res.code === 200 && res.data.canCheck ) {
            next()
          } else {
            next({
              path: '/aiHome'
            })
          }
        }).catch(err => {
          next({
            path: '/aiHome'
          })
        })
      }
    },
    {
      path: '/safeContent',
      name: 'safeContent',
      component: () => import('@/views/ContentSafe'),
      meta: { title: '新华网大语言模型集成测试服务平台' },
      beforeEnter: (to, from, next) => {
        const token = getUserToken()
        if(!token) {
          next({
            path: '/index'
          })
        }
        Api.verifyToken(token).then(res => {
          if ( res.code === 200 && res.data.canCheck ) {
            next()
          } else {
            next({
              path: '/index'
            })
          }
        }).catch(err => {
          next({
            path: '/index'
          })
        })
      }
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js